// extracted by mini-css-extract-plugin
module.exports = {"card":"Indicator_card__FwfeP","cardHeading":"Indicator_cardHeading__Yo6jS","cardTitle":"Indicator_cardTitle__2eGbK","cardBody":"Indicator_cardBody__wvDq0"};